import React from "react"
import LegalDocumentPage from "@/features/legal/components/LegalDocumentPage"
import { PRIVACY_POLICY } from "@/features/legal/content/legalContent"

const PrivacyPolicyPage: React.FC = () => <LegalDocumentPage legalDocument={PRIVACY_POLICY} />

export default PrivacyPolicyPage
